import api from './api';

export function getSettings() {
  return api.get('/api/v2/settings');
}
